var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useSWR from 'swr';
import { useRendererContext } from '../../../content-renderers/RendererContext';
import { getCurrentAccountID, safeLogError } from '../../../utils';
export function fetchUserProfile() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch('/api/v3/recommendations/user_profile');
        const data = yield response.json().catch(safeLogError);
        if (!response.ok) {
            throw new Error(`Failed to fetch user profile: ${(_a = data === null || data === void 0 ? void 0 : data.errors) !== null && _a !== void 0 ? _a : ['unknown error'].join(', ')} (${response.status})`);
        }
        return data.objects[0];
    });
}
export function useUserProfile(shouldFetch = true) {
    var _a, _b, _c, _d, _e, _f;
    const { data, error, isLoading } = useSWR(`/api/v3/recommendations/user_profile/${shouldFetch}`, () => {
        return shouldFetch && !!getCurrentAccountID() ? fetchUserProfile() : null;
    });
    const { prefetchedData } = useRendererContext();
    if (error) {
        safeLogError(error);
    }
    return {
        data: data
            ? Object.assign(Object.assign({}, data), { role_name: (_c = (_b = (_a = prefetchedData === null || prefetchedData === void 0 ? void 0 : prefetchedData.roles) === null || _a === void 0 ? void 0 : _a.find(({ id }) => id === data.role_id)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : null, company_size_display_range: (_f = (_e = (_d = prefetchedData === null || prefetchedData === void 0 ? void 0 : prefetchedData.companySizes) === null || _d === void 0 ? void 0 : _d.find(({ id }) => id === data.company_size_id)) === null || _e === void 0 ? void 0 : _e.display_range) !== null && _f !== void 0 ? _f : null }) : null,
        error,
        isLoading,
    };
}
//# sourceMappingURL=data.js.map